import { Container, Typography } from "@mui/material";
import { useEffect } from "react";
import { useCustomThemeContext } from "../../providers/customThemeProvider";
import EventForm from "../../components/events/EventForm";

export const CreateEvent: React.FC = () => {
  const { updateTheme } = useCustomThemeContext();

  // Update the theme when the component mounts
  useEffect(() => {
    updateTheme();
  }, []);

  return (
    <Container disableGutters>
      {/* Display the page title */}
      <Typography variant="h4" align={"center"}>
        Create Event
      </Typography>
      {/* Render the EventForm component */}
      <EventForm submitButtonText="Create Event" />
    </Container>
  );
};

export default CreateEvent;
